module.exports = __webpack_public_path__ + "img/1041326.jpg";